<!--
 * @Author: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @Date: 2023-12-08 14:49:32
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-12-08 15:16:33
 * @FilePath: \合联\oms\src\view\order\orderTimeoutInspection\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/order/orderTimeoutInspection";
export default {
  name: "orderTimeoutInspection",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis,
        beforeHandleList({ data }) {
          return data;
        }
      },
      config: {
        isGetList: true
      },
      footer: {
        show: () => false
      },
      modals: {},
      header: {
        searchs: [
          {
            key: "airway_number",
            placeholder() {
              return this.$tz("订单号码");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          algin: "center"
        },
        {
          name: () => this.$tz("订单号码"),
          key: "awbno",
          minWidth: 110
        },
        {
          name: () => this.$tz("上一个,轨迹"),
          key: "pre_status",
          minWidth: 110
        },
        {
          name: () => this.$tz("上一个,轨迹时间"),
          key: "pre_time",
          minWidth: 110
        },
        {
          name: () => this.$tz("超时,轨迹"),
          key: "status",
          minWidth: 110
        },
        {
          name: () => this.$tz("轨迹时间"),
          key: "time",
          minWidth: 110
        }
      ]
    };
  }
};
</script>

<style scoped></style>
